import { gql } from "@apollo/client";

export default gql`
  query PortfolioResultsCenter {
    portfolioResultsCenter {
      _id
      asset {
        ... on BrazilianCompanyPortfolioAsset {
          name
          primaryLogo
          industrySegment
          tickerSymbolPrefix
        }
      }
      financialHighlights {
        _id
        fiscalPeriodDate
        fiscalPeriodQuarter
        highlights
        oneLiners {
          author {
            _id
            fullName
            pictureUrl
          }
          comment
        }
      }
      netIncomeDiff {
        fiscalDate
        netIncome
      }
      latestFinancialsDeliveryDate
      analystRatings {
        analyst {
          _id
          firstName
        }
        rating
      }
    }
  }
`;
